const state = () => ({
  isEmergencyChecked: false
});

const getters = {
  isEmergencyChecked(state) {
    return state.isEmergencyChecked;
  }
};

const mutations = {
  setIsEmergencyChecked(state, payload) {
    state.isEmergencyChecked = payload;
  }
};

export const emergencyDisclaimer = {
  state,
  getters,
  mutations,
  namespaced: true
};
